// ==============================================
// SUPABASE CONFIGURATION FOR WEB
// ==============================================

import { createClient } from "@supabase/supabase-js";

// Supabase configuration
// You can either use environment variables or hardcode them
export const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://ciytwbkjgesbdjzegbxr.supabase.co";
export const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNpeXR3YmtqZ2VzYmRqemVnYnhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYyMzYwOTQsImV4cCI6MjA4MTgxMjA5NH0.RfxiijuSupbxxpG1faOuhCe91TDSd8vPAYbjyKIKyyM";

// Validate that credentials are present
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "❌ Missing Supabase credentials! Please add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your .env file"
  );
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      "x-client-info": "supabase-js-web",
    },
  },
  db: {
    schema: "public",
  },
});

// Export convenience functions
export const supabaseAuth = supabase.auth;
export const supabaseDb = supabase;

// Helper: Get current user
export const getCurrentUser = async () => {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  return user;
};

// Helper: Sign in
export const signIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  return { data, error };
};

// Helper: Sign up
export const signUp = async (email, password) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
  });
  return { data, error };
};

// Helper: Sign out
export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  return { error };
};

// Helper: Listen to auth changes
export const onAuthStateChange = (callback) => {
  return supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session);
  });
};

export default supabase;
